import {
  MOON_50,
  MOON_500,
  RED_550,
  SIENNA_500,
} from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const ResourceVariableWrapper = styled.div`
  margin: 12px 0px 0px 0px;
  display: flex;
  flex-direction: row;
  font-size: 14px;
`;

export const ResourceVariableTitle = styled.div`
  font-weight: 400;
  color: ${SIENNA_500};
  background-color: ${MOON_50};
  border-radius: 4px;
  padding: 4px 4px;
  font-family: 'Source Code Pro', monospace;
  align-items: center;
  font-size: 14px;
`;

export const ResourceVariableColon = styled.div`
  margin: 0px 8px;
  padding: 4px 0px;
  font-weight: 1000;
`;

export const ResourceVariableDescription = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: ${MOON_500};
`;

export const SelectDiv = styled.div`
  min-width: 100px;
`;

export const ErrorMessage = styled.div`
  font-size: 14px;
  color: ${RED_550};
`;
